import Home from "./components/Home.vue";
import Navbar from "./components/Navbar.vue";
import SignInNavBar from "./components/signInComponent/SignInNavBar";
const PersonDetail = (resolve) => {
  require.ensure(["./components/personComponents/PersonDetail"], () => {
    resolve(require("./components/personComponents/PersonDetail"));
  });
};

// import PersonDetail from "./components/personComponents/PersonDetail";
const PersonList = (resolve) => {
  require.ensure(["./components/personComponents/PersonList.vue"], () => {
    resolve(require("./components/personComponents/PersonList.vue"));
  });
};

// import PersonList from "./components/personComponents/PersonList.vue";
const Reports = (resolve) => {
  require.ensure(["./components/ReportComponents/Reports.vue"], () => {
    resolve(require("./components/ReportComponents/Reports.vue"));
  });
};
//import Reports from "./components/ReportComponents/Reports.vue";
const Login = (resolve) => {
  require.ensure(["./components/loginComponents/loginHome.vue"], () => {
    resolve(require("./components/loginComponents/loginHome.vue"));
  });
};
//import Login from "./components/loginComponents/loginHome.vue";
const ProjectList = (resolve) => {
  require.ensure(["./components/projectComponents/ProjectList.vue"], () => {
    resolve(require("./components/projectComponents/ProjectList.vue"));
  });
};
//import ProjectList from "./components/projectComponents/ProjectList.vue";
const ProjectDetail = (resolve) => {
  require.ensure(["./components/projectComponents/ProjectDetail.vue"], () => {
    resolve(require("./components/projectComponents/ProjectDetail.vue"));
  });
};
// import ProjectDetail from "./components/projectComponents/ProjectDetail.vue";
const ProjectCreate = (resolve) => {
  require.ensure(
    ["./components/projectComponents/ProjectCreateComponent.vue"],
    () => {
      resolve(
        require("./components/projectComponents/ProjectCreateComponent.vue")
      );
    }
  );
};
// import ProjectCreate from "./components/projectComponents/ProjectCreateComponent.vue";
const ProjectEdit = (resolve) => {
  require.ensure(["./components/projectComponents/ProjectEdit.vue"], () => {
    resolve(require("./components/projectComponents/ProjectEdit.vue"));
  });
};
//import ProjectEdit from "./components/projectComponents/ProjectEdit.vue";
const ProjectAliasCrud = (resolve) => {
  require.ensure(
    ["./components/projectComponents/ProjectAliasCRUD.vue"],
    () => {
      resolve(require("./components/projectComponents/ProjectAliasCRUD.vue"));
    }
  );
};
//import ProjectAliasCrud from "./components/projectComponents/ProjectAliasCRUD.vue";
const ProjectAliasCreate = (resolve) => {
  require.ensure(["./components/projectComponents/ProjectAliasCreate"], () => {
    resolve(require("./components/projectComponents/ProjectAliasCreate"));
  });
};
//import ProjectAliasCreate from "./components/projectComponents/ProjectAliasCreate";
const ProjectAliasUpdateDelete = (resolve) => {
  require.ensure(
    ["./components/projectComponents/ProjectAliasUpdateDelete"],
    () => {
      resolve(
        require("./components/projectComponents/ProjectAliasUpdateDelete")
      );
    }
  );
};
//import ProjectAliasUpdateDelete from "./components/projectComponents/ProjectAliasUpdateDelete";
const ProjectOutcomeCrud = (resolve) => {
  require.ensure(["./components/projectComponents/ProjectOutcomeCRUD"], () => {
    resolve(require("./components/projectComponents/ProjectOutcomeCRUD"));
  });
};
//import ProjectOutcomeCrud from "./components/projectComponents/ProjectOutcomeCRUD";
const ProjectOutcomeCreate = (resolve) => {
  require.ensure(
    ["./components/projectComponents/ProjectOutcomeCreate"],
    () => {
      resolve(require("./components/projectComponents/ProjectOutcomeCreate"));
    }
  );
};
//import ProjectOutcomeCreate from "./components/projectComponents/ProjectOutcomeCreate";
const ProjectOutcomeUpdateDelete = (resolve) => {
  require.ensure(
    ["./components/projectComponents/ProjectOutcomeUpdateDelete"],
    () => {
      resolve(
        require("./components/projectComponents/ProjectOutcomeUpdateDelete")
      );
    }
  );
};
//import ProjectOutcomeUpdateDelete from "./components/projectComponents/ProjectOutcomeUpdateDelete";
const SignInHome = (resolve) => {
  require.ensure(["./components/signInComponent/SignInHome"], () => {
    resolve(require("./components/signInComponent/SignInHome"));
  });
};
//import SignInHome from "./components/signInComponent/SignInHome";
const SignInMonthPicker = (resolve) => {
  require.ensure(["./components/signInComponent/SignInMonthPicker"], () => {
    resolve(require("./components/signInComponent/SignInMonthPicker"));
  });
};
//import SignInMonthPicker from "./components/signInComponent/SignInMonthPicker";
const SignInDayPicker = (resolve) => {
  require.ensure(["./components/signInComponent/SignInDayPicker"], () => {
    resolve(require("./components/signInComponent/SignInDayPicker"));
  });
};
//import SignInDayPicker from "./components/signInComponent/SignInDayPicker";
const PersonPicker = (resolve) => {
  require.ensure(["./components/signInComponent/PersonPicker"], () => {
    resolve(require("./components/signInComponent/PersonPicker"));
  });
};
//import PersonPicker from "./components/signInComponent/PersonPicker";
const ProjectPicker = (resolve) => {
  require.ensure(["./components/signInComponent/ProjectPicker"], () => {
    resolve(require("./components/signInComponent/ProjectPicker"));
  });
};
//import ProjectPicker from "./components/signInComponent/ProjectPicker";
const ImpactHome = (resolve) => {
  require.ensure(["./components/ImpactComponents/ImpactHome"], () => {
    resolve(require("./components/ImpactComponents/ImpactHome"));
  });
};
//import ImpactHome from "./components/ImpactComponents/ImpactHome";
const ImpactSelectProjectAlias = (resolve) => {
  require.ensure(
    ["./components/ImpactComponents/ImpactSelectProjectAlias"],
    () => {
      resolve(
        require("./components/ImpactComponents/ImpactSelectProjectAlias")
      );
    }
  );
};
//import ImpactSelectProjectAlias from "./components/ImpactComponents/ImpactSelectProjectAlias";
const ImpactSelectOutcome = (resolve) => {
  require.ensure(["./components/ImpactComponents/ImpactSelectOutcome"], () => {
    resolve(require("./components/ImpactComponents/ImpactSelectOutcome"));
  });
};
//import ImpactSelectOutcome from "./components/ImpactComponents/ImpactSelectOutcome";
const AddResponsiblePerson = (resolve) => {
  require.ensure(
    ["./components/personComponents/personAddComponents/AddResponsiblePerson"],
    () => {
      resolve(
        require("./components/personComponents/personAddComponents/AddResponsiblePerson")
      );
    }
  );
};
//import AddResponsiblePerson from "./components/personComponents/personAddComponents/AddResponsiblePerson";

const StaffOperatedSignIn = (resolve) => {
  require.ensure(["./components/signInComponent/StaffOperatedSignin"], () => {
    resolve(require("./components/signInComponent/StaffOperatedSignin"));
  });
};

const PeopleSearch = (resolve) => {
  require.ensure(
    ["./components/personComponents/personSearchComponents/PeopleSearch"],
    () => {
      resolve(
        require("./components/personComponents/personSearchComponents/PeopleSearch")
      );
    }
  );
};

const DeletePerson = (resolve) => {
  require.ensure(
    ["./components/personComponents/DeleteComponents/DeletePerson"],
    () => {
      resolve(
        require("./components/personComponents/DeleteComponents/DeletePerson")
      );
    }
  );
};

export const routes = [
  {
    path: "/home",
    name:"home",
    components: {
      default: Home,
      "navbar-top": Navbar,
    },
  },
  {
    // a test path for isolating and testing components ... just add a name
    path: "/test",
    components: {
      default: PeopleSearch,
    },
  },
  {
    path: "/staff-operated-signin",
    name: "staff-operated-signin",
    components: { default: StaffOperatedSignIn },
    children: [
      {
        path: "people-search",
        name: "people-search",
        components: { default: PeopleSearch },
      },
      {
        path: "project-picker",
        name: "soos-project-picker",
        components: {
          default: ProjectPicker,
        },
      },
    ],
  },
  {
    path: "/signin",
    name: "signin",
    components: {
      //default: RegisterOfSignedIn,
      default: SignInHome,
      "navbar-top": SignInNavBar,
    },
    children: [
      {
        path: "month-picker",
        name: "month-picker",
        components: {
          default: SignInMonthPicker,
        },
      },

      {
        path: "day-picker/:monthName",
        name: "day-picker",
        components: {
          default: SignInDayPicker,
        },
      },

      {
        path: "person-picker",
        name: "person-picker",
        components: {
          default: PersonPicker,
        },
      },
      {
        path: "project-picker",
        name: "project-picker",
        components: {
          default: ProjectPicker,
        },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    components: {
      default: Login,
    },
  },
  {
    path: "/reports",
    components: {
      default: Reports,
      "navbar-top": Navbar,
    },
  },
  {
    path: "/people",
    name: "people",
    components: {
      default: PersonList,
      "navbar-top": Navbar,
    },
  },
  {
    path: "/person/:id",
    name: "personDetail",
    components: { default: PersonDetail, "navbar-top": Navbar },
    children: [
      {
        path: "impactHome",
        name: "impactHome",
        components: { default: ImpactHome },
        children: [
          {
            path: "impactSelectOutcome",
            name: "impactSelectOutcome",
            components: { default: ImpactSelectOutcome },
          },
          {
            path: "impactSelectProjectAlias",
            name: "impactSelectProjectAlias",
            components: { default: ImpactSelectProjectAlias },
          },
        ],
      },
      {
        path: "addResponsiblePerson",
        name: "addResponsiblePerson",
        components: { default: AddResponsiblePerson },
      },
      {
        path: "deletePerson",
        name: "deletePerson",
        components: { default: DeletePerson },
      },
    ],
  },

  {
    path: "/project/:id",
    components: { default: ProjectDetail, "navbar-top": Navbar },
    children: [
      {
        path: "edit",
        name: "projectEdit",
        components: { default: ProjectEdit },
      },
      {
        path: "alias",
        name: "projectAlias",
        components: { default: ProjectAliasCrud },
        children: [
          {
            name: "aliasCreate",
            path: "create",
            components: { default: ProjectAliasCreate },
          },

          {
            name: "aliasUpdate",
            path: "create/update/:aliasId",
            components: { default: ProjectAliasUpdateDelete },
          },
        ],
      },
      {
        path: "outcome",
        name: "projectOutcome",
        components: { default: ProjectOutcomeCrud },
        children: [
          {
            name: "outcomeCreate",
            path: "create",
            components: { default: ProjectOutcomeCreate },
          },

          {
            name: "outcomeUpdate",
            path: "create/update/:outcomeId",
            components: { default: ProjectOutcomeUpdateDelete },
          },
        ],
      },
    ],
  },

  {
    path: "/projects",
    name: "projects",
    components: { default: ProjectList, "navbar-top": Navbar },
    children: [
      {
        path: "/projects/newproject",
        name: "addNewProject",
        components: { default: ProjectCreate },
      },
    ],
  },

  { path: "*", redirect: "/home" },
];
